import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { styled } from '@mui/material/styles';
function shouldForwardProp(propName) {
    return !['borderColor', 'disabled'].includes(propName);
}
const Label = styled('label', { shouldForwardProp }) `
  border: 1px solid;
  border-color: ${({ borderColor }) => borderColor};
  cursor: ${({ disabled }) => (disabled ? 'unset' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  margin: 0;
  &:hover {
    background-color: ${({ theme }) => theme.palette.grey[50]};
    border-color: ${({ theme }) => theme.palette.primary.main};
  }

  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  font-size: 16px;
  font-weight: 600;
  font-family: ${(props) => props.theme.typography.fontFamily};
  color: ${({ theme }) => theme.palette.grey[900]};
`;
const LabelContent = styled('div') `
  display: flex;
  flex: 1;
  flex-direction: row;
  gap: 6px;
`;
const LabelText = styled('div') `
  display: flex;
  flex: 1;
  justify-content: space-between;
`;
const Input = styled('input') `
  cursor: pointer;
  margin: 0;
  position: absolute;
  opacity: 0;
  height: 0;
  width: 0;
`;
const ToggleTile = ({ name, value, children, className = '', onChange = () => undefined, selected = false, disabled = false, type = 'checkbox', hasError = false, selectedContent, testId, }) => {
    const toggleChecked = (e) => {
        onChange(e);
    };
    let borderColor = '#E9EFF4';
    if (selected) {
        borderColor = hasError ? '#FF2222' : '#00ACF6';
    }
    return (_jsxs(Label, { disabled: disabled, borderColor: borderColor, htmlFor: `${name}-${value}`, className: className, "data-testid": testId, children: [_jsxs(LabelContent, { children: [_jsx(LabelText, { children: children }), _jsx("img", { src: selected ? '/img/icons/svg/RadioOn.svg' : '/img/icons/svg/RadioOff.svg', alt: "radiobox" }), _jsx(Input, { id: `${name}-${value}`, name: name, type: type, value: value, onChange: toggleChecked, defaultChecked: selected, disabled: disabled })] }), selected && selectedContent] }));
};
export default ToggleTile;
